import { Button } from "@/components/ui/button";
import { TokenForm } from "./token-recovery/TokenForm";
import { useTokenValidation } from "./token-recovery/useTokenValidation";
import type { TokenRecoveryProps } from "./token-recovery/types";

export const TokenRecovery = ({ onBack }: TokenRecoveryProps) => {
  const { isLoading, error, validateToken } = useTokenValidation();

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-white mb-4">
        Ingresar código de recuperación
      </h2>
      <TokenForm 
        onSubmit={validateToken}
        isLoading={isLoading}
        error={error}
      />
      <Button
        type="button"
        variant="ghost"
        onClick={onBack}
        className="w-full text-white hover:bg-white/10"
      >
        Volver al inicio de sesión
      </Button>
    </div>
  );
};